import { share } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { StorageMap } from '@ngx-pwa/local-storage';
import { SESSION_STORAGE } from '../constants/session-storage';
import { PhdsoftErrorService } from './phdsoft-error.service';
import { Util } from '../util';
import { Base64 } from 'js-base64';

@Injectable({
  providedIn: 'root',
})
export class StorageService implements OnDestroy {
  private onSubject = new Subject<{ key: string; value: any }>();
  public changes = this.onSubject.asObservable().pipe(share());

  constructor(private storeMap: StorageMap, private errorService: PhdsoftErrorService) {
    this.start('');
  }

  ngOnDestroy(): void {
    this.stop();
  }

  public async getItem<T>(name: string, decript?: boolean, defaultValue?: any): Promise<T> {
    let response: T | any = await this.storeMap.get(name).toPromise();

    try {
      if (!Util.isNullOrUndefined(response)) {
        response = JSON.parse(Base64.decode(response));
      }
    } catch (error) {
      if (Util.isNullOrUndefined(response) && !Util.isNullOrUndefined(defaultValue)) {
        response = (defaultValue as string).replace('"', '');
      } else if (!Util.isNullOrUndefined(response) && Util.isJson(response)) {
        response = JSON.parse(response);
      }
    }

    return response;
  }

  public store(key: string, data: any, crypt?: boolean): void {

    if (crypt) {
      if (!Util.isString(data)) {

        data = Base64.encode(JSON.stringify(data));
      } else {
        data = Base64.encode(data);
      }
    } else if (!Util.isString(data)) {
      data = JSON.stringify(data);
    }

    this.storeMap.set(key, data).subscribe(
      (value: undefined) => { },
      (error) =>
        this.errorService.snack(error, 'Offline database access fail. No more space on disk'),
    );
    // the local application doesn't seem to catch changes to localStorage...
    // this.onSubject.next({ key: key, value: data })
  }

  public async storeAsync(key: string, data: any, crypt: boolean = true): Promise<void> {
    if (!Util.isNullOrUndefined(data)) {
      if (crypt) {
        data = Base64.encode(JSON.stringify(data));
      } else {
        data = JSON.stringify(data);
      }
      return await this.storeMap.set(key, data).toPromise();
    }
    return null;
  }

  public removeItem(key): void {
    this.storeMap.delete(key).subscribe(() => { });
  }

  public async reset(): Promise<void> {
    // Check if the database exists
    const databases = await indexedDB.databases();
    const dbExists = databases.some(db => db.name === 'PhDsoft_Cache');

    if (!dbExists) {
      console.log('Database does not exist, skipping reset');
      return;
    }
    return await this.storeMap.clear().toPromise();
  }

  public start(customerId: string): void {
    window.addEventListener('storage', this.storageEventListener.bind(this));
  }

  private storageEventListener(event: StorageEvent): void {
    if (event.storageArea === localStorage || event.storageArea === sessionStorage) {
      let _event;
      try {
        _event = JSON.parse(event.newValue);
        if ((event.key === SESSION_STORAGE.TOKEN && event.newValue == null) || event.key == null) {
          Notification.requestPermission((result) => {
            if (result === 'granted') {
              navigator.serviceWorker.ready.then((value) => {
                value.showNotification('Session', {
                  body: 'Session Expired!',
                  icon: '/statics/icons/android-chrome-192x192.png',
                  data: 'Session Expired',
                  //vibrate: [200, 100, 200, 100, 200, 100, 200],
                });
              });
            }

            //setTimeout(() => window.location.reload(), 1000);
          });
        }
      } catch (e) {
        _event = event.newValue;
      }
      this.onSubject.next({ key: event.key, value: _event });
    }
  }

  public stop(): void {
    window.removeEventListener('storage', this.storageEventListener.bind(this));
    this.onSubject.complete();
  }

  private replaceQuotes(str: any): string {
    return str.replace(/\'/gm, ``);
  }
}
